import * as React from 'react';

import { truncate } from 'lodash';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import { COURSE_PROGRAM_CHAR_LIMIT } from 'bundles/notification-center/constants';
import type {
  LearnerEnrollInProgramMessage as LearnerEnrollInProgramMessageType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: LearnerEnrollInProgramMessageType;
  onClick: (notification: NotificationType) => void;
};

const LearnerEnrollInProgramMessage = ({ notification, onClick }: Props) => {
  const href = `/programs/${notification.data.programSlug}`;
  return (
    <Notification notification={notification} onClick={onClick} href={href}>
      <FormattedHTMLMessage
        message={_t('Welcome to <b>{programName}</b>. Explore these courses curated by your organization.')}
        programName={truncate(notification.data.programName, { length: COURSE_PROGRAM_CHAR_LIMIT })}
      />
    </Notification>
  );
};

export default LearnerEnrollInProgramMessage;
